module.exports = __webpack_public_path__ + "img/error.25e88953.svg";